import React from 'react';
import cssmodules from 'react-css-modules';
import styles from './processcipform.cssmodule.scss';
import { Link } from 'react-router';
import Select from 'react-select';
import {injectIntl, intlShape, FormattedRelative} from 'react-intl';

import classNames from 'classnames';
import IdeaStateLabel from '../Shared/IdeaStateLabel';
import { Radio, FormGroup} from 'react-bootstrap';
import {convertCipIdeaStateName, CIP_TYPE} from '../../constants';
import {FormattedDate, FormattedTime} from 'react-intl';
var NotificationSystem = require('react-notification-system');


class ProcessCipForm extends React.Component {
  constructor(props) {
    super(props);
    const {cipIdea} = props;
    const {cipFiles} = props;
    const Progress = Object.assign({}, cipIdea.Progress ? cipIdea.Progress : {Comment : ''}, {State : cipIdea.State , CipIdeaId : cipIdea.Id});

    this.state = {
      cipIdeaId : cipIdea.Id,
      Progress : Progress
    }
  }

  componentDidMount() {
     const {cipIdea} = this.props;
     const Progress = Object.assign({}, cipIdea.Progress ? cipIdea.Progress : {Comment : ''}, {State : cipIdea.State , CipIdeaId : cipIdea.Id});
     this.setState({
        cipIdeaId : cipIdea.Id,
        Progress : Progress
     });
     this._notificationSystem = this.refs.notificationSystem;
  }


  componentWillReceiveProps(nextProps) { 
     const {cipIdea} = nextProps;
     const {cipFiles} = nextProps;
     const Progress = Object.assign({}, cipIdea.Progress ? cipIdea.Progress : {Comment : ''}, {State : cipIdea.State, CipIdeaId : cipIdea.Id});
     this.setState({
        cipIdeaId : cipIdea.Id,
        Progress : Progress
     });
  }

  handleProgressChange(propertyName, event){
    const {Progress} = this.state;
    let newProgress = {...Progress, [propertyName] : event.target.value};
    this.setState({
        Progress : newProgress
     });
  }

  submitClicked(){
    let onSubmit = this.props.onSubmit;
    const {intl} = this.props;
    const t = (message, data = {}) => {
        if(!message) return '';
        return intl.formatMessage({id : message}, data);
    };

    if(onSubmit){
      onSubmit(this.state.Progress).then(() => {
          this._notificationSystem.addNotification({
              title : t("Success"),
              message: t("SAVE_CIP_OK"),
              level: 'success',
              position : 'br'
          });
      });
    }
  }

  render() {
    
    const {intl} = this.props;
    const t = (message, data = {}) => {
        if(!message) return '';
        return intl.formatMessage({id : message}, data);
    };
    
    const {cipIdea} = this.props;
    const {cipFiles} = this.props;
    const {Progress} = this.state;
    const canSubmit = Progress.Comment && Progress.State;
    const hasFiles = (cipFiles && cipFiles.Files && cipFiles.Files.length > 0);

    const {authInfo} = this.props;
    const Authorized = authInfo.IsAdmin || (authInfo.LocalInfo && cipIdea.CipGroup && authInfo.LocalInfo.Id == cipIdea.CipGroup.CipGroupManagerId);
    const inWorkFlow = authInfo.IsAdmin || (Authorized && cipIdea.State < 2);
    
    return (
      <form className="processcipform-component form-horizontal form-condensed" styleName="processcipform-component">
                <NotificationSystem ref="notificationSystem" />
                <div className="form-group">
                   <label className="control-label col-xs-3">{t('Id')} :</label>
                   <div className="col-xs-9">
                      <p className="form-control-static">{cipIdea.Id}</p>
                  </div>
                </div>

                <div className="form-group">
                   <label className="control-label col-xs-3">{t('Title')} :</label>
                   <div className="col-xs-9">
                      <p className="form-control-static">{cipIdea.Title}</p>
                  </div>
                </div>
                <div className="form-group">
                   <label className="control-label col-xs-3">{t('Created by')} :</label>
                   <div className="col-xs-9">
                      <p className="form-control-static">{cipIdea.Author ? cipIdea.Author.DisplayName : ''}</p>
                  </div>
                </div>
                <div className="form-group">
                   <label className="control-label col-xs-3">{t('Created date')} :</label>
                   <div className="col-xs-9">
                      <p className="form-control-static">
                        <FormattedDate className="form-control-static" value={cipIdea.Created ? cipIdea.Created : new Date()}/>&nbsp;
                        <FormattedTime className="form-control-static" value={cipIdea.Created ? cipIdea.Created : new Date()}/>
                      </p>
                  </div>
                </div>

                {
                  cipIdea.CloseDate && <div className="form-group">
                    <label className="control-label col-xs-3">{t('Closed date')} :</label>
                    <div className="col-xs-9">
                        <p className="form-control-static">
                          <FormattedDate className="form-control-static" value={cipIdea.CloseDate}/>&nbsp;
                          <FormattedTime className="form-control-static" value={cipIdea.CloseDate}/>
                        </p>
                    </div>
                  </div>
                }

                <div className="form-group">
                   <label className="control-label col-xs-3">{t('State')} :</label>
                   <div className="col-xs-9">                     
                      <p className="form-control-static"><IdeaStateLabel type={CIP_TYPE} state={cipIdea.State}/></p>
                      
                  </div>
                </div>
                <div className="form-group">
                  <label className="control-label col-xs-3">{t('CIP-Group')} :</label>
                  <div className="col-xs-9">
                      <p className="form-control-static">{cipIdea.CipGroup ? cipIdea.CipGroup.Title : ''}</p>
                  </div>
                  
                </div>
                <div className="form-group">
                  <label className="control-label col-xs-3">{t('Author')} :</label>
                   <div className="col-xs-9">
                      <p className="form-control-static">{cipIdea.Author ? cipIdea.Author.DisplayName : ''}</p>
                  </div>
                </div>
                <div className="form-group">
                  <label className="control-label col-xs-3">{t('Proposal')} :</label>
                  <div className="col-xs-9">
                      <p className="form-control-static word-break">{cipIdea.Description}</p>
                  </div>
                </div>
                {
                  hasFiles && (<div className="form-group">
                    <label className="control-label col-xs-3">{t('Attached files')} :</label>
                    <div className="col-xs-9">
                        <ul className="list-unstyled">
                          {
                            cipFiles.Files.map((file, idx)=> (<li key={file.Id}> <a href={file.url}>{file.FileName}</a> </li>))
                          }
                        </ul>
                    </div>
                  </div>
                  )
                }
                <div className="form-group">
                  <label className="control-label col-xs-3">{t('Comment')} :</label>
                  <div className="col-xs-9">
                      <textarea readOnly={!inWorkFlow} rows="4" className="form-control" value={Progress.Comment} onChange={this.handleProgressChange.bind(this, 'Comment')}/>
                  </div>
                </div>

                {
                  inWorkFlow && 
                    <div className="form-group">
                      <label className="control-label col-xs-3">{t('State')} :</label>
                      <FormGroup className="col-xs-9">
                          <Radio value="1" checked={Progress.State == 1}  name="stateOptions" onChange={this.handleProgressChange.bind(this, 'State')}>
                              {t(convertCipIdeaStateName(1))}
                            </Radio>
                            <Radio value="2" checked={Progress.State == 2} name="stateOptions" onChange={this.handleProgressChange.bind(this, 'State')}>
                              {t(convertCipIdeaStateName(2))}
                            </Radio>
                            <Radio value="3" checked={Progress.State == 3}  name="stateOptions" onChange={this.handleProgressChange.bind(this, 'State')}>
                              {t(convertCipIdeaStateName(3))}
                            </Radio>
                      </FormGroup>
                    </div>                
                }
                {  inWorkFlow &&  
                  <button onClick={this.submitClicked.bind(this)} disabled={!canSubmit} type="button" className="btn btn-default btn-brand pull-right">
                    {t('Save and send')}
                  </button>
                }
      </form>
    );
  }
}

ProcessCipForm.displayName = 'ProcessCipForm';
ProcessCipForm.propTypes = {};
ProcessCipForm.defaultProps = {};

export default injectIntl(cssmodules(ProcessCipForm, styles));



// WEBPACK FOOTER //
// ./components/ProcessIdeas/ProcessCipForm.js